import { useIntl, FormattedMessage } from 'react-intl';
import { Style } from '@/components/style';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { TW_address } from '@/constants/Address';
import { cloneDeep, isEmpty } from 'lodash';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  setSelectCity,
  setSelectArea,
  setStructuredAddress,
} from '@/actions/uberDirect/uberDirectAction';
import '@/components/welcome/welcome.scss';

const { alertColor, blackColor, primaryColor } = new Style().getUiConfig();

function AddressSelector({ city, setCity, area, setArea }) {
  const intl = useIntl();
  const dispatch = useDispatch<any>();
  const style = new Style();

  const webStoreVoFromWelcome = useSelector(
    (state: RootStateOrAny) => state.welcomeReducer
  );
  const webStoreVoFromOrder = useSelector(
    (state: RootStateOrAny) => state.orderReducer
  );
  const structuredAddress = useSelector(
    (state: RootStateOrAny) => state.uberDirectReducer.structuredAddress
  );

  const cityData = () => {
    const addressAreas =
      webStoreVoFromWelcome?.webStoreVoResponse?.data?.webStoreVo
        ?.addressAreas ||
      webStoreVoFromOrder?.webStoreVoResponse?.data?.webStoreVo?.addressAreas;
    const tempCityData = TW_address.map((data) => {
      return data.name;
    });

    if (!addressAreas) return tempCityData;

    const filterCityData = addressAreas.map((data) => {
      return data.name;
    });

    const intersectionCityData = tempCityData.filter((element) => {
      return filterCityData.includes(element);
    });

    if (!intersectionCityData) return tempCityData;

    return intersectionCityData;
  };

  const initAreaData = (cityName) => {
    if (!cityName) return [];
    const areas = cloneDeep(
      TW_address.filter((data) => data.name === cityName)[0].districts
    );
    const tempAreaData = areas.map((data) => {
      return data.name;
    });
    return tempAreaData;
  };

  const areaData: any = initAreaData(city);

  const updateStructAddress = (cityValue, areaValue) => {
    const tempStructAddress = cloneDeep(structuredAddress);
    if (isEmpty(tempStructAddress)) return;
    tempStructAddress.state = cityValue;
    tempStructAddress.city = areaValue;

    dispatch(setStructuredAddress(tempStructAddress));
  };

  return (
    <div className="d-flex justify-content-between">
      {/* choose city */}
      <div style={{ width: '50%', textAlign: 'left', position: 'relative' }}>
        <button
          className="btn btn-lg address"
          style={
            city
              ? {
                  border: `1px solid ${style.getUiConfig().gray3Color}`,
                  color: `${style.getUiConfig().blackColor}`,
                  paddingLeft: '10px',
                }
              : {
                  border: `1px solid ${style.getUiConfig().gray3Color}`,
                  color: `${style.getUiConfig().gray3Color}`,
                  paddingLeft: '10px',
                }
          }
          type="button"
          data-testid="cityDropDownMenu"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {city ? `${city}` : '縣市'}
        </button>
        <ul
          className="dropdown-menu address-list"
          style={{ width: '100%', border: '1px solid #8D8C8C' }}
          id="cityDropDownMenu"
          aria-labelledby="cityDropDownMenu"
        >
          {cityData()?.map((data) => (
            <li key={data} className="div-hover">
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ height: '40px' }}
                onClick={() => {
                  setCity(data);
                  dispatch(setSelectCity(data));
                  const selectArea = initAreaData(data)[0];
                  setArea(selectArea);
                  dispatch(setSelectArea(selectArea));
                  updateStructAddress(data, selectArea);
                }}
              >
                {data}
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* choose area */}
      <div style={{ width: '50%', textAlign: 'right', position: 'relative' }}>
        <button
          className="btn btn-lg address"
          style={
            area
              ? {
                  border: `1px solid ${style.getUiConfig().gray3Color}`,
                  color: `${style.getUiConfig().blackColor}`,
                  paddingLeft: '10px',
                  width: '98%',
                }
              : {
                  border: `1px solid ${style.getUiConfig().gray3Color}`,
                  color: `${style.getUiConfig().gray3Color}`,
                  paddingLeft: '10px',
                  width: '98%',
                }
          }
          type="button"
          data-testid="areaDropDownMenu"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {area ? `${area}` : '區域'}
        </button>
        <ul
          style={{ width: '100%', border: '1px solid #8D8C8C' }}
          className="dropdown-menu address-list"
          aria-labelledby="areaDropDownMenu"
        >
          {areaData?.map((data) => (
            <li key={data} className="div-hover">
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  height: '40px',
                }}
                onClick={() => {
                  setArea(data);
                  dispatch(setSelectArea(data));
                  updateStructAddress(city, data);
                }}
              >
                {data}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

AddressSelector.defaultProps = {
  city: null,
  area: null,
};

AddressSelector.propTypes = {
  city: PropTypes.string,
  setCity: PropTypes.func.isRequired,
  area: PropTypes.string,
  setArea: PropTypes.func.isRequired,
};

export default AddressSelector;
